import { createElementBlock as t, openBlock as o, createElementVNode as n } from "vue";
const r = {
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-phone"
};
function s(C, e) {
  return o(), t("svg", r, e[0] || (e[0] = [
    n("path", {
      d: "M14.2244 8.39667C14.0595 7.98452 13.775 7.6312 13.4074 7.38227C13.0398 7.13334 12.6061 7.00019 12.1622 7H9.10556C8.54713 7 8.01157 7.22183 7.6167 7.6167C7.22183 8.01157 7 8.54713 7 9.10556C7 18.9878 15.0111 27 24.8956 27C25.4538 26.9997 25.9891 26.7777 26.3837 26.3829C26.7783 25.9881 27 25.4527 27 24.8944V21.8378C27 21.3937 26.867 20.9597 26.618 20.592C26.3691 20.2242 26.0157 19.9394 25.6033 19.7744L22.6744 18.6033C22.3025 18.4545 21.8973 18.409 21.5016 18.4715C21.1059 18.5341 20.7345 18.7025 20.4267 18.9589L19.6711 19.59C19.2449 19.9453 18.7013 20.1283 18.147 20.1032C17.5928 20.0781 17.0679 19.8467 16.6756 19.4544L14.5467 17.3222C14.1546 16.9302 13.9232 16.4059 13.8979 15.8521C13.8726 15.2982 14.0553 14.755 14.41 14.3289L15.04 13.5733C15.2969 13.2656 15.4659 12.8941 15.5288 12.4982C15.5918 12.1023 15.5465 11.6967 15.3978 11.3244L14.2244 8.39667Z",
      stroke: "#115DAF",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--accent-blue"
    }, null, -1)
  ]));
}
const c = { render: s };
export {
  c as default,
  s as render
};
